import type { FC, ReactNode } from 'react'
import { useState } from 'react'

import type { WhiteLabel } from '@skytech/types'
import ChevronUpIcon from 'mdi-react/ChevronUpIcon'
import { twJoin } from 'tailwind-merge'

import { Button } from '../Button'

import './styles.scss'

export type CardProps = {
  children: ReactNode
  className?: string
  hasColoredShadow?: boolean
  marginBottom?: number
  marginRight?: number
  marginTop?: number
  marginLeft?: number
  paddingBottom?: number
  paddingTop?: number
  paddingRight?: number
  paddingLeft?: number
  isFullWidth?: boolean
  noMargin?: boolean
  noPadding?: boolean
  collapsible?: boolean
  isInitiallyCollapsed?: boolean
}

export const Card: FC<CardProps> = ({
  className = '',
  children,
  hasColoredShadow,
  marginBottom = 16,
  marginRight = 16,
  marginTop = 16,
  marginLeft = 16,
  paddingBottom = 16,
  paddingTop = 16,
  paddingRight = 16,
  paddingLeft = 16,
  noMargin,
  noPadding,
  collapsible,
  isInitiallyCollapsed,
}) => {
  // todo: replace with the org from url when ready
  const storedWhiteLabel = localStorage.getItem('org') as WhiteLabel
  const whiteLabel = storedWhiteLabel || 'control'

  const [isCardCollapsed, setIsCardCollapsed] = useState(isInitiallyCollapsed)

  const style: Record<string, number> = {
    marginBottom,
    marginRight,
    marginTop,
    marginLeft,
    paddingBottom,
    paddingTop,
    paddingLeft,
    paddingRight,
  }

  if (noPadding) style.padding = 0
  if (noMargin) style.margin = 0

  return (
    <div
      style={style}
      className={`ui-card ${className} ${isCardCollapsed ? 'is-collapsed' : ''} ${whiteLabel} ${
        hasColoredShadow ? 'has-colored-shadow' : ''
      }`}
    >
      {collapsible ? (
        <Button
          className={twJoin(
            'absolute right-0 top-4 transition duration-100 ease-in-out',
            isCardCollapsed && '-rotate-180 transform'
          )}
          size="small"
          variant="tertiary"
          Icon={<ChevronUpIcon />}
          onClick={() => setIsCardCollapsed(!isCardCollapsed)}
        />
      ) : null}
      {children}
    </div>
  )
}
